/**
 * @generated SignedSource<<af3c8a5bebf5266f70498fc3fc1b77d6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterBooleanOperator = "AND" | "NOT" | "OR" | "%future added value";
export type FilterElementInput = {
  multiple?: FilterBooleanOperationInput | null | undefined;
  single?: FilterValueInput | null | undefined;
};
export type FilterValueInput = {
  name: string;
  operator?: string | null | undefined;
  qualifier?: string | null | undefined;
  value?: string | null | undefined;
  values?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type FilterBooleanOperationInput = {
  operands: ReadonlyArray<FilterElementInput>;
  operator: FilterBooleanOperator;
};
export type CreateDpcRootQuery$variables = {
  accountGroupFilterElement?: FilterElementInput | null | undefined;
  uuid: string;
};
export type CreateDpcRootQuery$data = {
  readonly __id: string;
  readonly repositoryConfig: {
    readonly repositoryConfig: {
      readonly uuid: any;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"useProblemsAlert_problems">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AdminPage_query" | "UpsertDpcForm_query">;
};
export type CreateDpcRootQuery = {
  response: CreateDpcRootQuery$data;
  variables: CreateDpcRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountGroupFilterElement"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uuid"
},
v2 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "uuid"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roleAssignmentPrincipal",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000
},
v10 = [
  (v9/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateDpcRootQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AdminPage_query"
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "RepositoryConfigPayload",
        "kind": "LinkedField",
        "name": "repositoryConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RepositoryConfig",
            "kind": "LinkedField",
            "name": "repositoryConfig",
            "plural": false,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useProblemsAlert_problems"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UpsertDpcForm_query"
      },
      {
        "kind": "ClientExtension",
        "selections": [
          (v4/*:: as any*/)
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "CreateDpcRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "whoami",
        "plural": false,
        "selections": [
          (v5/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          (v6/*:: as any*/),
          (v7/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UrlConfig",
            "kind": "LinkedField",
            "name": "UrlConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "docs",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*:: as any*/)
        ]
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "RepositoryConfigPayload",
        "kind": "LinkedField",
        "name": "repositoryConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RepositoryConfig",
            "kind": "LinkedField",
            "name": "repositoryConfig",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "problems",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "message",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Problems",
            "abstractKey": "__isProblems"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v10/*:: as any*/),
        "concreteType": "UserGroupConnection",
        "kind": "LinkedField",
        "name": "userGroups",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserGroup",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "userGroups(first:1000)"
      },
      {
        "alias": null,
        "args": (v10/*:: as any*/),
        "concreteType": "UserConnection",
        "kind": "LinkedField",
        "name": "users",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*:: as any*/),
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "users(first:1000)"
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "filterElement",
            "variableName": "accountGroupFilterElement"
          },
          (v9/*:: as any*/)
        ],
        "concreteType": "AccountGroupConnection",
        "kind": "LinkedField",
        "name": "accountGroups",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountGroup",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  (v3/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "roleAssignmentTarget",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userPermissions",
                    "storageKey": null
                  },
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bdaabb6436b83c584813862d601a9b0e",
    "id": null,
    "metadata": {},
    "name": "CreateDpcRootQuery",
    "operationKind": "query",
    "text": "query CreateDpcRootQuery(\n  $uuid: String!\n  $accountGroupFilterElement: FilterElementInput\n) {\n  ...AdminPage_query\n  repositoryConfig(uuid: $uuid) {\n    repositoryConfig {\n      uuid\n      id\n    }\n    ...useProblemsAlert_problems\n  }\n  ...UpsertDpcForm_query\n}\n\nfragment ACLFormFields_query on Query {\n  ...ACLPrincipalPicker_principals\n  whoami {\n    email\n    name\n    roleAssignmentPrincipal\n  }\n}\n\nfragment ACLPrincipalPicker_principals on Query {\n  userGroups(first: 1000) {\n    edges {\n      node {\n        name\n        roleAssignmentPrincipal\n        id\n      }\n    }\n  }\n  users(first: 1000) {\n    edges {\n      node {\n        email\n        name\n        roleAssignmentPrincipal\n        id\n      }\n    }\n  }\n}\n\nfragment AccountGroupPicker_accountGroups_1VU2v9 on Query {\n  accountGroups(filterElement: $accountGroupFilterElement, first: 1000) {\n    edges {\n      node {\n        name\n        uuid\n        roleAssignmentTarget\n        userPermissions\n        id\n      }\n    }\n  }\n}\n\nfragment AdminPage_query on Query {\n  ...PageWithBreadCrumbs_query\n}\n\nfragment BreadCrumbsHeader_query on Query {\n  whoami {\n    email\n    displayName\n  }\n}\n\nfragment PageWithBreadCrumbs_query on Query {\n  ...BreadCrumbsHeader_query\n}\n\nfragment UpsertDpcForm_query on Query {\n  ...ACLFormFields_query\n  ...AccountGroupPicker_accountGroups_1VU2v9\n}\n\nfragment useProblemsAlert_problems on Problems {\n  __isProblems: __typename\n  problems {\n    __typename\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "41c5d1812d1b18cfcd7156569fab1a2e";

export default node;
